var __WEBPACK_NAMESPACE_OBJECT__ = require("roboflex-thalamus-sso-lib/dist");